import React from 'react';

export const TableRow = ({ children }: { children: React.ReactNode }) => {
  return <tr className='odd:bg-gray-90'>{children}</tr>;
};

export default TableRow;
